import axios, { isAxiosError } from "axios"
import { useEffect, useState } from "react"
import Loadingwrapper from "../../component/LoadingWrapper"
import useAddImageToCollection from "../../hooks/useAddImageToCollection"
import useCollectionNames from "../../hooks/useCollectionNames"
import ImagesDiv from "./ImagesDiv"

const NewsFeedNewmeTrendPopup = ({ gender, category, tag, value, retailer = 'newme', isPage = false }) => {

  const [socialImages, setSocialImages] = useState([])
  const [retailerFactoryImages, setRetailerFactoryImages] = useState([])
  const [retailerLiveImages, setRetailerLiveImages] = useState([])
  const [loading, setLoading] = useState(false)
  const [allCollectionNames, socialcollectionSets, retailercollectionSets, getCollectionNames] = useCollectionNames()
  const addImageToCollection = useAddImageToCollection()


  const socialAddImageToCollectionWrapper = (image, collectionId) => {
    addImageToCollection(image._id, collectionId, socialcollectionSets, 'social', getCollectionNames);
  }

  const retailerAddImageToCollectionWrapper = (image, collectionId) => {
    addImageToCollection(image._id, collectionId, retailercollectionSets, 'retailer', getCollectionNames);
  }

  const getNewsFeedImages = async (signal) => {
    setLoading(true)
    try {
      const response = await axios.get(`/api/news-feed/retailer-factory-images?gender=${gender}&category=${encodeURIComponent(category)}&tag=${encodeURIComponent(tag)}&value=${encodeURIComponent(value)}&retailer=${retailer}`, { signal })
      setSocialImages(response.data.socialImages)
      setRetailerFactoryImages(response.data.retailerFactoryImages)
      setRetailerLiveImages(response.data.retailerLiveImages)
      setLoading(false)
    } catch (e) {
      if (!isAxiosError(e)) {
        console.error(e)
      }
    }
  }

  useEffect(() => {
    console.log(socialImages, retailerLiveImages, retailerFactoryImages)
  }, [socialImages, retailerLiveImages, retailerFactoryImages])

  useEffect(() => {
    const controller = new AbortController()
    const signal = controller.signal
    getNewsFeedImages(signal)
    return () => {
      controller.abort()
    }
  }, [gender, category, tag, value])


  return <div className={`${isPage ? '' : 'w-[80vw] h-[80vh]'}`}>
    <h3 className="text-center font-semibold text-[20px]">{value != '#N/A' ? value : 'No Specific'} {tag} Trend Images</h3>
    {!loading ? <div>
      <p className="font-semibold text-sm italic p-2">Newme_factory_ products are {retailerFactoryImages.length}, and Newme_ products are {retailerLiveImages.length}</p>
    </div> : null}
    <div className={`flex justify-between mt-4 border-t border-black`}>
      <Loadingwrapper loading={loading}>
        <ImagesDiv images={socialImages} type={'social'} allCollectionNames={allCollectionNames} addImageToCollection={socialAddImageToCollectionWrapper} collectionSets={socialcollectionSets} fetchCollections={getCollectionNames} />
        <div className="w-0.5 bg-black"></div>
        <ImagesDiv images={retailerFactoryImages} type={'retailer'} allCollectionNames={allCollectionNames} addImageToCollection={retailerAddImageToCollectionWrapper} collectionSets={retailercollectionSets} fetchCollections={getCollectionNames} />
        <div className="w-0.5 bg-black"></div>
        <ImagesDiv images={retailerLiveImages} type={'retailer'} allCollectionNames={allCollectionNames} addImageToCollection={retailerAddImageToCollectionWrapper} collectionSets={retailercollectionSets} fetchCollections={getCollectionNames} />
      </Loadingwrapper>
    </div>
  </div >

}

export default NewsFeedNewmeTrendPopup
